<template>
  <div class="task-body">
    <template>
      <div v-if="(List && List.length > 0) || IsFilter">
        <div class="task-table" style="margin-top: 2%;margin-bottom: 2%;">
          <div class="task-search-filter">
            <ul class="clearfix list-unstyled list-inline" style="margin:0px;">
              <li class="pull-left" style="margin-left: 20px;">
                <ob-input class="search-bar" style="display: inline-block;" icon="fa-search" placeholder="Search..." :disabled="IsLoading " value="searchText" v-model.trim="searchText" @keyup.native.enter="searchData" @click="searchData"></ob-input>
                <span><ob-button class="search-btn" :disabled="IsLoading || searchText == ''" @click="searchData">Search</ob-button></span>
                <ob-button class="clear-btn" type="link" v-if= "isSearchApplied"  @click="clearSearch" >Clear</ob-button>
              </li>
              <li>
                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_filter.svg`" alt="image" :disabled="IsLoading" @click="showFilter = true" style="margin-top: 10px;"/>
                <ob-button class="clear-btn" type="link" v-if="isFilterApplied && !showFilter"  @click="clearFilter" >Clear</ob-button>
              </li>
              <ul class="pull-right list-unstyled list-inline" style="margin-right:10px;">
                <li>
                  <div class="add-task">
                    <a @click="openAddTaskPopup = true  ; isEdit = false">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
                      <span style="color: #000000;font-weight: 600;font-size: 12px;">
                        Add Task
                      </span>
                    </a>
                  </div>
                </li>
                <li>
                  <ul class="list-unstyled list-inline routes_ul">
                    <li class="pagination-count-txt" style="color: #000000">{{From}} - {{To}} of {{tasksTotalCount}}</li>
                    <li><ob-button type="secondary" class="pagination__controls pagination__controls--left" icon="fa fa-caret-left" @click="prevPage" :disabled="PageIndex == 0 || tasksTotalCount < PageSize || IsLoading"></ob-button></li>
                    <li><ob-button type="secondary" class="pagination__controls pagination__controls--right" icon="fa fa-caret-right" @click="nextPage" :disabled="tasksTotalCount < PageSize || tasksTotalCount == To || IsLoading"></ob-button></li>
                  </ul>
                </li>
                <li>
                  <span v-if="!isListView" @click="isListView = true"><img class="img-list" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_listview.svg`"/></span>
                  <span v-else  @click="isListView = true"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_listview-selected.svg`"/></span>
                </li>
                <li>
                  <span v-if="isListView"  @click="isListView = false"><img class="img-gridview" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_gridview.svg`"/></span>
                  <span v-else  @click="isListView = false"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_gridview-selected.svg`"/></span>
                </li>
              </ul>
            </ul>
            <task-filter v-show="showFilter"  @cancel="cancelFilter" @apply="applyFilter" :isSupervisor="isSupervisor" :showFilter="showFilter"></task-filter>
          </div>
        </div>
        <template v-if="isListView">
          <ob-table v-if="!openTaskDetailPopup" 
            :isRowClickable="true" 
            @rowClick="handleRowClick"
            style="z-index: -1 !important;padding:0px 12px;" 
            :fixed-body="tableHeight" 
            :table-header="tableHeader" 
            :table-data="List" 
            :config="config" ref="maintable"
            :IsFromTaskList="true">
            <template v-for="(td, tdIndex) in List">
              <template v-for="(th, thIndex) in tableHeader">
                <template :slot="`l-slot-${th.key}-${tdIndex}`" >
                  <div v-if="th.key == 'LinkedEmployeesList'">
                    <popover-list :IsFromTaskList="true" :Trainees.sync='td.LinkedEmployeesList'></popover-list>
                  </div>
                </template>
                <template :slot="`m-slot-${th.key}-${tdIndex}`" >
                  <div v-if="th.key == 'LinkedEmployeesList'">
                    <popover-list :IsFromTaskList="true" :Trainees.sync='td.LinkedEmployeesList'></popover-list>
                  </div>
                </template>
              </template>
            </template>
            <template slot="th">
              <th><span class="cell-data">Actions</span></th>
            </template>
            <template v-for="(item, index) in List" :slot="`td${item[config.primaryKey]}${index}`">
              <td :key="`actions${item[config.primaryKey]}`">
                <ob-dropdown title="Actions" class="js-stop-propagate-class">
                  <ob-dropdown-list-item :class="{'deleteTask':deleteDisable(item)}" @click.native="editTask(item)" style="white-space: nowrap;">Edit</ob-dropdown-list-item>
                  <ob-dropdown-list-item :class="{'deleteTask':deleteDisable(item)}" @click.native="confirmDeletetask(item)" style="white-space: nowrap;">Delete</ob-dropdown-list-item>
                </ob-dropdown>
              </td>
            </template>
          </ob-table>
        </template>
        <template v-else>
          <div style="padding: 10px;">
           <template v-for="(item, index) in List">
            <div class="col-md-4" style="padding: 4px;">
              <div class="card-view" @click="onClickCard(item)">
                <div class="col-md-12" style="height: 70px;">
                  <ul class="pull-left clearfix list-unstyled list-inline" style="margin:0px">
                    <li>
                      <span class="task-title"> {{item.Title}}</span>
                    </li>
                  </ul>
                  <ul class="pull-right clearfix list-unstyled list-inline task-actions" style="margin:0px;">
                    <li id="editButton" :class="{'deleteTask':deleteDisable(item)}" @click.stop="editTask(item)">
                      <span><i class="fa fa-pencil" aria-hidden="true" ></i></span>
                    </li>
                    <li id="deleteButton" :class="{'deleteTask':deleteDisable(item)}" @click.stop="confirmDeletetask(item)">
                      <span><i class="fa fa-trash" aria-hidden="true" ></i></span>
                    </li>
                  </ul>
                </div>
                <div class="col-md-12">
                  <span class="task_date"><img style="width: 20px;margin-right: 6px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timestamp.svg`"></span>
                  <span  style="font-size:11px"> {{item.CreatedDate}}</span>
                  <!-- <span v-if="item.Status != 'None'" v-bind:class="item.Status == 'Pending' ? 'status':'status1'">{{item.Status}}</span> -->
                </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="tasks_empty" v-else>
        <div style="margin-bottom:20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_notasks.svg`"/></div>
        <div style="font-size: 14px;margin-bottom:15px;">You haven’t added any task yet. Try adding a new one.</div>
        <div>
          <a @click="openAddTaskPopup = true  ; isEdit = false">
            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
            <span style="color:#464444;font-weight: 600;">
              Add Task
            </span>
          </a>
        </div>
      </div>
    </template>
    <ob-modal2 :show.sync="openDeleteTaskPopup" :type="1" width="540px">
        <div class="" style="padding:30px 30px;text-align:center">
          <img style="width:100px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/reminder_note.svg`" />
          <p class="warning-content" style="color: #e46481;font-size:18px;">Delete Task</p>
          <h4 style="display: inline;line-height: 20px;">By deleting task will erase all information regarding this task.<br> Are you sure want to delete?
          </h4>
          <div style="padding-top:3%" v-if="linkedEmpLength > 1">
            <ob-checkbox name="check-box" v-model="IsDeleteAll"><span class="checkbox-label" style="font-size:13px;color: #2c2c3de8;font-weight: 600;">Delete this task for other linked ({{linkedEmpLength-1}}) employees</span></ob-checkbox>
          </div>   
        </div>
        <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
          <ob-button type="secondary"  @click="openDeleteTaskPopup = false, IsDeleteAll = false">Cancel</ob-button>
          <ob-button @click="deleteTask">Delete</ob-button>
        </div>
      </ob-modal2>
    <task-details v-if="openTaskDetailPopup" :openModal.sync="openTaskDetailPopup" :taskId="selectedTaskId"></task-details>
    <add-task :openModal.sync="openAddTaskPopup" :IsEdit ="isEdit" :PreviousData ="previousData"></add-task>
  </div>
</template>
<script>
import utils from "Vue/Core/utils.js";
import AddTask from './AddTask.vue';
import TaskDetails from './TaskDetails.vue';
import TaskFilter from './TaskFilter.vue';
import ReportingTraineeCircle from "../ESSDashboard/ReportingTraineeCircle";
export default {
  props: ["TaskList","tasksTotalCount","IsFilter","isSupervisor"],
    data() {
      return {
        IsDeleteAll:false,
        openDeleteTaskPopup:false,
        taskId:'',
        linkedEmpLength:0,
        isListView:true,
        isEdit:false,
        previousData:'',
        PageIndex: 0,
        PageSize: 20,
        openTaskDetailPopup:false,
        selectedTaskId:'',
        openAddTaskPopup: false,
        searchText:'',
        IsLoading: false,
        isSearchApplied: false,
        isFilterApplied: false,
        showFilter: false,
        config: {
        primaryKey: "Id",
        fixedCols: {
          left: 0,
          right: 0
        }
      },
      tableHeader: [
        {
          key: "Title",
          name: "Title",
          transform: (o) => {
            return `<span title="${o.Title}">${this.getName(o.Title)}</span>`
          },
        },
        {
          key: "CreatedDate",
          name: "Created Date",
        },
        {
          key: "EstimatedDuration",
          name: "Estimated Duration",
          transform: (o) => {
            return o.EstimatedDuration
          },
        },
        {
          key: "CreatedBy",
          name: "Created By",
          transform: (o) => {
            return o.CreatedBy.FirstName +" "+ o.CreatedBy.LastName
          },
        }
        // {
        //   key: "Status",
        //   name: "Evaluation Status",
        //   transform: (o) => {
        //     if(o.Status == 'None'){
        //       return `N/A`
        //     }else{
        //       return o.Status
        //     }
        //   }
        // },
      ]
    }
  },
  components: {
    "add-task": AddTask,
    "task-filter": TaskFilter,
    "task-details":TaskDetails,
    "reporting-training-circle": ReportingTraineeCircle,
  },
  computed: {
    tableHeight(){
        return "calc(100% - -1px)"
    },
    List()
    {
      return this.TaskList
    },
    From(){
      if(this.tasksTotalCount == 0){
        return 0
      }
      else{
        return (this.PageIndex * this.PageSize) + 1
      }
    },
    To(){
      if(this.tasksTotalCount == 0){
        return 0
      }
      else if(this.tasksTotalCount < this.PageSize){
        return this.tasksTotalCount
      }
      else {
        let fT = (this.From + this.PageSize) - 1
        if(fT > this.tasksTotalCount)
          return this.tasksTotalCount
        else
          return fT
      }
    },
  },
  created() {
      this.isListView = this.$route.query.isListview != undefined ? this.$route.query.isListview : true
      if(this.$route.name != "employee-tasks"){
        this.tableHeader.push({
          key: "LinkedEmployeesList",
          name: "Linked Employees",
          slot:true
        })
      }
  },
  watch:{
    searchText(val){
      if(val.length > 0){
          this.showClearSearch = true
      }
      else{
          this.showClearSearch = false
      }
    },
  },
  methods: {
    getName(v){
      var fileLength = v.length
      if(fileLength > 33)
      {
        return v.substring(0,30) + "...";
      }
      else return v
    },
    cancelFilter(){
      this.showFilter = false
    },
    applyFilter(){
      this.showFilter = false
      this.searchData()
    },
    searchData(){
      if(this.searchText && this.searchText.length > 0){
        this.isSearchApplied = true
        this.PageIndex = 0
        this.isFilterApplied = false
        let searchObj = {
          SearchKey : this.searchText,
          PageIndex : this.PageIndex,
          PageSize : this.PageSize
        }
        this.$parent.fetchData(searchObj)
      }
    },
    clearSearch(){
      this.searchText = ''
      this.PageIndex = 0
      var Obj = {IsFilter : true}
      this.$parent.fetchData(Obj)
      this.isSearchApplied=false
    },
     clearFilter(){
      this.PageIndex = 0
      var Obj = {IsFilter : true}
      this.$parent.fetchData(Obj)
      this.isFilterApplied=false
      events.fire("ClearingtheTaskFilteredData")
    },
    prevPage(){
      this.PageIndex = (this.PageIndex - 1)
       var Obj = {IsFilter : true,PageIndex :this.PageIndex}
      this.$parent.fetchData(Obj)
    },
    nextPage(){
      this.PageIndex = (this.PageIndex + 1)
      var Obj = {IsFilter : true,PageIndex :this.PageIndex}
      this.$parent.fetchData(Obj)
    },
    filter()
    {
      this.isFilterApplied = true
      this.isSearchApplied = false
    },
    handleRowClick(e, item) {
      let from = this.$route.query.from
      var empId =  this.$route.query.EmployeeId
      if(utils.findAncestor(e.target, 'js-stop-propagate-class') === null) {
        if(from){
          this.$router.push({name: 'employee-tasks-details', params: { id: item.TaskId}, query: {id:item.TaskId,EmployeeId:empId,from: from,isListview:this.isListView }})
        } else {         
           this.$router.push({name: `employee-tasks-details`, params: { id: item.TaskId}, query: {id:item.TaskId, EmployeeId:this.loggedInUserObj.empId, isListview:this.isListView }}) 
        }
      }
    },
    onClickCard(item){
        let from = this.$route.query.from
        var empId =  this.$route.query.EmployeeId
        if(from){
          this.$router.push({name: 'employee-tasks-details', params: { id: item.TaskId}, query: { EmployeeId:empId,from: from,isListview:this.isListView}})
        } else {
          this.$router.push({name: `employee-tasks-details`, params: { id: item.TaskId}, query: {id:item.TaskId, EmployeeId:this.loggedInUserObj.empId, isListview:this.isListView }})
        }
    },
    deleteDisable(item){
      if(this.$route.name != 'employee-tasks'){
        return false
      }
      else {
        if(item.TaskCreatedBy.Email == this.loggedInUserObj.email){
          return false
        }
        else return true
      }
    },
    confirmDeletetask(item) {
      let from = this.$route.query.from
      this.taskId = item.TaskId
      if(!this.deleteDisable(item)){
        if(from != null && from != '' && from != 'ess-dashboard'){
          this.openDeleteTaskPopup = true
          this.linkedEmpLength = item.LinkedEmployeesList.length
        }
        else{
          this.$alert2("Are you sure you want to delete ?", "Alert", {
            type: "confirm",
            yesButtonText: "Yes",
            noButtonText: "No",
            callback: (action) => {
              if(action === true) {
                this.deleteTask();
              }
            }
          });
        }
      }      
    },
    deleteTask() {
      var empId =  this.$route.query.EmployeeId
      var obj = {}
      obj.EmployeeId = empId ? empId : this.loggedInUserObj.empId
      obj.IsDeleteAll = this.IsDeleteAll
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.put(`/Task/${this.taskId}/Delete`, obj , (response) => {
        this.IsDeleteAll = false
        this.openDeleteTaskPopup = false
        if(response.data.State == true){
          this.$parent.fetchData('delete')
            this.$loading({}).close()
        }
      })
    },
    editTask(obj){
      if(!this.deleteDisable(obj)){
        this.isEdit = true
        this.previousData = obj
        this.openAddTaskPopup = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fixed-height {
        height: 100%;
    }
    .task-filter{
      float: left;
    }
    .add-task{
      padding-right: 10px;
    }
    .search{
      padding-right: 0px !important;
      padding-left: 0px !important;
    }
    .tasks_empty{
      margin-top: 14%;
      text-align: center;
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
    .pagination {
      padding-right: 0;
      margin-top: 20px;
    }
    button.pagination__controls {
      background: #fff;
      -webkit-appearance: none;
      border: 1px solid #979797;
      padding: 3px 10px;
    }
    button.pagination__controls--left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    button.pagination__controls--right {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .card-view{
       padding: 10px 0 10px 10px;
       border: 2px solid #f5f5f5;
       height: 130px;
       background: #fff;
       position: relative;
       display: table;
       width: 100%;
       border-radius:5px;
       .task-title{
          font-size: 13px;
          font-weight: 600
       }
    }

.card-view:hover{
  -webkit-box-shadow: 0px 4px 14px 0px rgba(177,180,188,0.2);
   box-shadow: 0px 4px 14px 0px rgba(177,180,188,0.2);
}
 .card-view:hover  .task-actions
 {
    display: block;
 }
  .task-actions{
    display: none;
  }
  #deleteButton:hover,#editButton:hover{
    border-radius: 3px;
    // padding: 1px 5px;
    background-color: #E8E8E9;
  }
 .status{
    color:#F5A623;
    margin-left: 0px;
    border: 1px solid #F5A623 !important;
    background: #FEF6E9 !important;
    padding: 1px 12px;
    display: inline-block;
    border-radius: 30px;
    float: right;
    font-size: 12px;
    font-weight: 600;
  }
   .status1{
    color:#34BB93;
    margin-left: 0px;
    border: 1px solid #34BB93 !important;
    background: #E8F4F1 !important;
    padding: 1px 12px;
    display: inline-block;
    border-radius: 30px;
    float: right;
    font-size: 12px;
    font-weight: 600;
  }
  .img-gridview:hover
  {
    filter: brightness(0.1);
  }
  .img-list:hover
  {
    filter: brightness(0.1);
  }
  .deleteTask{
    cursor: not-allowed !important;
    color: #00000057 !important;
  }
  .warning-content{
    font-weight: 600;
    font-size: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/TaskTable.vue